import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import UsersApi from '../../apis/Users';
import renewLogo from '../../assets/renew-logo.png';
import CustomInput from '../../components/CustomInput';
import CustomButton from '../../components/CustomButton';
import './LoginScreen.css';

const LoginScreen = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const navigate = useNavigate();
  const { login } = useAuth();

  const usersApi = new UsersApi(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await usersApi.login(email, password, (token) => {
        login(token);
        navigate('/home');
      });

      console.log('Login successful:', response);
    } catch (err) {
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="responsive-container">
      <div className="login-container">
        <div className="logo-section">
          <img src={renewLogo} alt="RENEW Logo" className="logo-image" />
        </div>

        {/* Welcome Section */}
        <div className="welcome-section">
          <h2 className="welcome-title">Welcome back!</h2>
          <p className="welcome-subtitle">Log in to track your energy usage</p>
        </div>

        {/* Login Form */}
        <div className="login-form-card">
          <form onSubmit={handleSubmit} className="login-form">
            <CustomInput
              type="email"
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="User@gmail.com"
            />

            <CustomInput
              type="password"
              label="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
            />

            <CustomButton type="submit" disabled={loading} variant="primary" size="medium" className="login-button">
              {loading ? 'Logging in...' : 'Log in'}
            </CustomButton>

            <div className="forgot-password">
              <button type="button" className="forgot-password-link">
                Forgot Password?
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
